/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Tree_Title_2Inputs */

const en_daily_paywall_tree_title_2 = /** @type {(inputs: Daily_Paywall_Tree_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock new trees 3x faster`)
};

const ar_daily_paywall_tree_title_2 = /** @type {(inputs: Daily_Paywall_Tree_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افتح أشجارًا جديدة بسرعة أكبر بثلاث مرات`)
};

const de_daily_paywall_tree_title_2 = /** @type {(inputs: Daily_Paywall_Tree_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Bäume 3x schneller freischalten`)
};

const es_daily_paywall_tree_title_2 = /** @type {(inputs: Daily_Paywall_Tree_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquea nuevos árboles 3 veces más rápido`)
};

const fr_daily_paywall_tree_title_2 = /** @type {(inputs: Daily_Paywall_Tree_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débloquez de nouveaux arbres 3 fois plus vite`)
};

const it_daily_paywall_tree_title_2 = /** @type {(inputs: Daily_Paywall_Tree_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocca nuovi alberi 3x più velocemente`)
};

const ja_daily_paywall_tree_title_2 = /** @type {(inputs: Daily_Paywall_Tree_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい木を3倍速でアンロック`)
};

const ko_daily_paywall_tree_title_2 = /** @type {(inputs: Daily_Paywall_Tree_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`신상 나무를 3배 더 빠르게 획득하세요`)
};

const pt_br_daily_paywall_tree_title_2 = /** @type {(inputs: Daily_Paywall_Tree_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueie novas árvores 3x mais rápido`)
};

const ru_daily_paywall_tree_title_2 = /** @type {(inputs: Daily_Paywall_Tree_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разблокируйте новые деревья в 3 раза быстрее`)
};

const th_daily_paywall_tree_title_2 = /** @type {(inputs: Daily_Paywall_Tree_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลดล็อกต้นไม้ใหม่ได้เร็วขึ้น 3 เท่า`)
};

const tr_daily_paywall_tree_title_2 = /** @type {(inputs: Daily_Paywall_Tree_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni ağaçların kilidini 3 kat daha hızlı aç`)
};

const zh_cn_daily_paywall_tree_title_2 = /** @type {(inputs: Daily_Paywall_Tree_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 倍速解锁新树`)
};

const zh_tw_daily_paywall_tree_title_2 = /** @type {(inputs: Daily_Paywall_Tree_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 倍速解鎖新樹`)
};

/**
* | output |
* | --- |
* | "Unlock new trees 3x faster" |
*
* @param {Daily_Paywall_Tree_Title_2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_tree_title_2 = /** @type {((inputs?: Daily_Paywall_Tree_Title_2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Tree_Title_2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_tree_title_2(inputs)
	if (locale === "ar") return ar_daily_paywall_tree_title_2(inputs)
	if (locale === "de") return de_daily_paywall_tree_title_2(inputs)
	if (locale === "es") return es_daily_paywall_tree_title_2(inputs)
	if (locale === "fr") return fr_daily_paywall_tree_title_2(inputs)
	if (locale === "it") return it_daily_paywall_tree_title_2(inputs)
	if (locale === "ja") return ja_daily_paywall_tree_title_2(inputs)
	if (locale === "ko") return ko_daily_paywall_tree_title_2(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_tree_title_2(inputs)
	if (locale === "ru") return ru_daily_paywall_tree_title_2(inputs)
	if (locale === "th") return th_daily_paywall_tree_title_2(inputs)
	if (locale === "tr") return tr_daily_paywall_tree_title_2(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_tree_title_2(inputs)
	return zh_tw_daily_paywall_tree_title_2(inputs)
});